<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="6">
            <el-form-item label="购买页主题图" required>
              <activityCustomUpload :formName="'camp_background_image'" :formValue="form.camp_background_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="拉新页主题图" required>
              <activityCustomUpload :formName="'invited_background_image'" :formValue="form.invited_background_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="领取福利弹窗" required>
              <activityCustomUpload :formName="'receive_product'" :formValue="form.receive_product" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="页面色号" required>
              <el-input size="medium" v-model="form.background_color" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.background_color,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="导流图标" >60*60
              <activityCustomUpload :formName="'icon_guide'" :formValue="form.icon_guide" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
            <el-form-item label="导流链接">
              <el-input size="medium" v-model="form.link_guide" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="入营准备悬浮图标" >60*60
              <activityCustomUpload :formName="'icon_guide2'" :formValue="form.icon_guide2" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
            <el-form-item label="入营准备悬浮链接">
              <el-input size="medium" v-model="form.link_guide2" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row>
          <template v-for="(item,index) in form.poster_url_list">
            <el-col :span="6" v-bind:key="index">
              <el-form-item :label="'分享海报' + (index+1)" >
                <activityCustomUpload :formName="'url_' + index" :formValue="item" @uploadSuccess="uploadSuccess"></activityCustomUpload>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
         <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import {
  getInfo, savePageElementInfo
} from "@/api/activityCamp";

export default {
  components: { activityCustomUpload },
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        camp_background_image:'',
        invited_background_image:'',
        background_color:'',
        receive_product:'',
        poster_url_list:['',''],
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
    }
  },
  created: function () {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false
        this.info = response.data
        this.form = response.data.page_element;
        for (let i = 0; i < 8; i++){
          if(typeof this.form.poster_url_list[i] == "undefined"){
            this.form.poster_url_list.push('');
          }
        }
      });
    },
    uploadSuccess(value){
      let temp = value.formName.split('_');
      if (temp[0] == 'url') {
        this.$set(this.form.poster_url_list, temp[1], value.fileUrl)
        // this.form.poster_url_list[temp[1]] = value.fileUrl
      } else {
        this.$set(this.form, value.formName, value.fileUrl)
        // this.form[value.formName] = value.fileUrl
      }
    },
    onSave(){
      this.onSaveLoading = true;
      let that = this
      savePageElementInfo({
        id: this.id,
        form: this.form
      }).then(res => {
        that.onSaveLoading = false;
        if(res.code == 1){
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });
    },
    backPrePage(){
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}
</style>